module.exports = __webpack_public_path__ + "img/logo-e.3b9b9e71.png";